import React, { useState, useEffect, useMemo } from 'react';
import { Card, toast, FormatCurrency, constants } from 'day8-ui';
import { IoMdRadioButtonOff } from "@react-icons/all-files/io/IoMdRadioButtonOff";
import { IoMdRadioButtonOn } from "@react-icons/all-files/io/IoMdRadioButtonOn";
import InstalmentsOption from './components/InstalmentsOption';
import RecurringPaymentsOption from './components/RecurringPaymentsOption';
import PayLaterOption from './components/PayLaterOption';
import { updateSearch, getQuery } from '../../../helpers/querystring';
import PayFullOption from './components/PayFullOption';
import history from '../../../history';
import PaymentPageToPay from '../PaymentPageToPay';
import { BOOKING } from '../../../constants';

const { MAX_PAYMENT_AMOUNT } = constants;

const PaymentOptions = props => {
  const { paymentOption } = getQuery(props.location);
  const [activePaymentOption, setActivePaymentOption] = useState(paymentOption || 'payFull');
  const [isScheduledPaymentsAvailable, setIsScheduledPaymentsAvailable] = useState(false);
  const [isInstalmentsAvailable, setIsInstalmentsAvailable] = useState(false);
  const { scheduledPayments, mainOrder } = props.booking;
  const orderDeadlinesArray = mainOrder.orderDeadlines || [];
  const scheduledPaymentsAvailable = !!scheduledPayments.length;
  useEffect(() => {
    setIsScheduledPaymentsAvailable(scheduledPaymentsAvailable);
    setIsInstalmentsAvailable(!!orderDeadlinesArray.length);
    if (!scheduledPaymentsAvailable && !orderDeadlinesArray.length) {
      // make sure this is opened by default in case it's the only option
      updateActivePaymentOption('payFull');
    } else {
      setActivePaymentOption(paymentOption);
    }
  }, []);
  const disableUpdatingActivePaymentOption = useMemo(() => {
    const query = getQuery(history.location);
    return !!query['cko-session-id'];
  }, [history.location]);

  const updateActivePaymentOption = selectedOption => {
    if (disableUpdatingActivePaymentOption) {
      toast.warning("Processing payment, please wait.");
      return;
    }
    const newSelectedOption = selectedOption === activePaymentOption ? null : selectedOption;
    setActivePaymentOption(newSelectedOption);
    props.history.replace({
      pathname: props.location.pathname,
      search: updateSearch(props.location, { paymentOption: newSelectedOption })
    });
  };
  if (props.forcePayLater) {
    return (
      <div className="margin-y-sm">
        <PayLaterOption
          {...props}
          isActive={activePaymentOption === 'payLater'}
          setActivePaymentOption={updateActivePaymentOption}
          activePaymentOption={activePaymentOption}
        />
      </div>
    );
  }
  const isPaymentOverLimit = mainOrder.gross > MAX_PAYMENT_AMOUNT;
  const cabins = props.booking.capacity > 2 ? 'cabins' : 'cabin';
  let amountToPay = 0;
  if (props.allowPayLater) {
    amountToPay = 10000;
  }
  return (
    <div>
      <h2 className='dui-text-2xl dui-mb-4'>Secure your booking</h2>
      {props.allowPayLater && (
        <Card cardType={activePaymentOption === 'payLater' ? 'BORDERED_ACTIVE' : "BORDERED"} className=''>
          <div className='dui-w-full dui-text-left dui-flex dui-items-center dui-justify-between dui-cursor-pointer' onClick={() => updateActivePaymentOption('payLater')}>
            <div>
              <p className='dui-font-medium'>Secure booking with <FormatCurrency
                amount={amountToPay / 100}
                baseCurrency={mainOrder.currency}
                round={true}
              />{" "}
              </p>
              <p className='dui-mt-1 dui-text-sm'>Reserve your yacht now, pay in {props.firstDeadlineDays > 1 ? `${props.firstDeadlineDays} days` : '24 hours'}.</p>
            </div>
            {activePaymentOption === 'payLater' ? <IoMdRadioButtonOn /> : <IoMdRadioButtonOff />}
          </div>
        </Card>
        // <Card cardType={activePaymentOption === 'payLater' ? 'BORDERED_ACTIVE' : "BORDERED"} className=''>
        //   <div className='dui-w-full dui-text-left dui-flex dui-items-center dui-justify-between dui-cursor-pointer' onClick={() => updateActivePaymentOption('payLater')}>
        //     <div>
        //       <p className='dui-font-medium'>Pay Later</p>
        //       <p className='dui-mt-1 dui-text-sm'>Reserve your yacht now, pay in {props.firstDeadlineDays > 1 ? `${props.firstDeadlineDays} days` : '24 hours'}.</p>
        //     </div>
        //     {activePaymentOption === 'payLater' ? <IoMdRadioButtonOn /> : <IoMdRadioButtonOff />}
        //   </div>
        // </Card>
      )}
      <Card cardType={activePaymentOption === 'payFull' ? 'BORDERED_ACTIVE' : "BORDERED"} className=''>
        <div className='dui-w-full dui-text-left dui-flex dui-items-center dui-justify-between dui-cursor-pointer' onClick={() => updateActivePaymentOption('payFull')}>
          <div>
            <p className='dui-font-medium'>Pay in full</p>
            <p className='dui-mt-1 dui-text-sm'>
              Pay for your trip in {isPaymentOverLimit ? 'two' : 'one'} payment{isPaymentOverLimit ? 's' : ''} of{" "}
              <FormatCurrency
                amount={(isPaymentOverLimit ? mainOrder.gross / 2 : mainOrder.gross) / 100}
                baseCurrency={mainOrder.currency}
                round={false}
              />
            </p>
          </div>
          {activePaymentOption === 'payFull' ? <IoMdRadioButtonOn /> : <IoMdRadioButtonOff />}
        </div>
      </Card>
      {isInstalmentsAvailable && (
        <Card cardType={activePaymentOption === 'instalments' ? 'BORDERED_ACTIVE' : "BORDERED"} className=''>
          <div className='dui-w-full dui-text-left dui-flex dui-items-center dui-justify-between dui-cursor-pointer' onClick={() => updateActivePaymentOption('instalments')}>
            <div>
              <p className='dui-font-medium'>Payment Plan</p>
              <p className='dui-mt-1 dui-text-sm'>Pay <FormatCurrency
                amount={orderDeadlinesArray[0].amount / 100}
                baseCurrency={mainOrder.currency}
                round={false}
              /> {" "} now and rest in {orderDeadlinesArray.length - 1} instalments
              </p>
            </div>
            {activePaymentOption === 'instalments' ? <IoMdRadioButtonOn /> : <IoMdRadioButtonOff />}
          </div>
        </Card>

      )}
      {isScheduledPaymentsAvailable && (
        <Card cardType={activePaymentOption === 'recurring' ? 'BORDERED_ACTIVE' : "BORDERED"} className=''>
          <div className='dui-w-full dui-text-left dui-flex dui-items-center dui-justify-between dui-cursor-pointer' onClick={() => updateActivePaymentOption('recurring')}>
            <div>
              <p className='dui-font-medium'>Automated Payment Plan</p>
              <p className='dui-mt-1 dui-text-sm'>
                Pay <FormatCurrency
                  amount={orderDeadlinesArray[0].amount / 100}
                  baseCurrency={mainOrder.currency}
                  round={false}
                />{" "}
              now and {props.booking.scheduledPayments.length} monthly payments of <FormatCurrency
                  amount={props.booking.scheduledPayments[0].amount / 100}
                  baseCurrency={mainOrder.currency}
                  round={false}
                />{" "} at 0% APR</p>
            </div>
            {activePaymentOption === 'recurring' ? <IoMdRadioButtonOn /> : <IoMdRadioButtonOff />}
          </div>
        </Card>
      )}
      <p className="dui-mt-4 dui-text-sm">*Not sure which plan&#39;s right for you? See our full Payment FAQ&#39;s <a href="https://help.theyachtweek.com/en/?q=payments+cancellation" className='dui-font-semibold' target="_blank" rel="noopener noreferrer">here</a> to find out.</p>
      <PaymentPageToPay className="dui-mt-4" booking={props.booking} />
      {/* Active section content */}
      {props.allowPayLater && activePaymentOption === 'payLater' && (
        <InstalmentsOption {...props} amountToPay={amountToPay} isActive={activePaymentOption === 'payLater'} setActivePaymentOption={updateActivePaymentOption} activePaymentOption={activePaymentOption} />
      )}
      {activePaymentOption === 'payFull' && (
        <PayFullOption {...props} isActive={activePaymentOption === 'payFull'} setActivePaymentOption={updateActivePaymentOption} activePaymentOption={activePaymentOption} isPaymentOverLimit={isPaymentOverLimit} />
      )}
      {isInstalmentsAvailable && activePaymentOption === 'instalments' && (
        <InstalmentsOption {...props} isActive={activePaymentOption === 'instalments'} setActivePaymentOption={updateActivePaymentOption} activePaymentOption={activePaymentOption} />
      )}
      {isScheduledPaymentsAvailable && activePaymentOption === 'recurring' && (
        <RecurringPaymentsOption {...props} isActive={activePaymentOption === 'recurring'} setActivePaymentOption={updateActivePaymentOption} activePaymentOption={activePaymentOption} />
      )}
    </div>
  );
};
export default PaymentOptions;
